/**
 * The guard that stops a failed reload becoming a reload loop.
 *
 * Its own module because the boundary next to it is a component, and a file
 * that exports both a component and a helper loses fast refresh.
 */

// One key for the whole session: a chunk that is genuinely missing must not
// reload the page forever.
export const reloadKey = 'pecgoprof:chunk-reload'

/**
 * Clears the guard once a page has rendered successfully, so the next deploy
 * gets its own single reload rather than being refused one.
 */
export function clearChunkReloadGuard(): void {
  sessionStorage.removeItem(reloadKey)
}
